import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var GaugeIcon = function GaugeIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "GaugeIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 2.361c-2.291 0-4.15 1.872-4.15 4.18 0 2.31 1.858 4.181 4.15 4.181 2.291 0 4.15-1.871 4.15-4.18 0-2.31-1.859-4.18-4.15-4.18m-5.5 4.18C2.5 3.482 4.962 1 8 1s5.5 2.481 5.5 5.542c0 2.83-2.106 5.165-4.825 5.5v1.597h4.15c.373 0 .675.305.675.68s-.302.681-.675.681h-9.65a.68.68 0 0 1-.675-.68c0-.376.302-.681.675-.681h4.15v-1.597c-2.72-.335-4.825-2.67-4.825-5.5",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.789 4.74a.49.49 0 0 1 0 .687l-.857.863A.969.969 0 0 1 8 7.514a.97.97 0 0 1-.965-.972.97.97 0 0 1 1.215-.94l.856-.862a.48.48 0 0 1 .683 0",
      clipRule: "evenodd"
    })]
  }));
};

export { GaugeIcon };
